// Documentation here https://support.wisepops.com/en/articles/2269220-wisepops-on-single-page-applications
export default function ({ app }) {
  /* eslint-disable */
  const script = document.createElement('script')
  script.dataset.cfasync = false
  script.innerHTML = `(function(W,i,s,e,P,o,p){W['WisePopsObject']=P;W[P]=W[P]||function(){(W[P].q=W[P].q||[]).push(arguments)},W[P].l=1*new Date();o=i.createElement(s),p=i.getElementsByTagName(s)[0];o.defer=1;o.src=e;p.parentNode.insertBefore(o,p)})(window,document,'script','//loader.wisepops.com/get-loader.js?v=1&site=rWw3iWPV5X','wisepops');`

  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(script, s)

  setTimeout(() => {
    if (window.wisepops) window.wisepops('options', { autoPageview: false })
  }, 0)

  app.router.afterEach(
    () =>
      setTimeout(() => {
        if (window.wisepops) window.wisepops('pageview')
      }),
    0
  )
}
